import React from "react";
import CardLists from "../../components/organisation/CardLists";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import OrganisationLayout from "../../components/organisation/layout/OrganisationLayout";
import {
  OrganisationResultItem,
  OrganisationDashboardResult,
  EmptyResult,
} from "../../components/organisation";
import { BaseButton, Spinner } from "../../components/base";
import { fetchOrganisationDashboardAnalytics } from "../../store/slices/organisation/action";
import { Order } from "../../store/slices/order/types";
import { useAppSelector, useAppDispatch } from "../../store";
import OrganisationOrderItem from "../../components/organisation/OrganisationOrderItem";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const OrganisationDashboard = () => {
  const [order, setOrder] = useState<Order>();
  const { dashboardInfo } = useAppSelector(
    (state) => state.organisationReducer
  );
  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );

  const [isLoading, setIsLoading] = useState(false);

  // const { organisationId } = useParams();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const handleShowModal = (result: Order) => {
    setShow(!show);
    setOrder(result);
  };

  useEffect(() => {
    const onLoad = async () => {
      if (currentOrganisationAccount?.organisationId) {
        setIsLoading(true);
        const res = await dispatch(
          fetchOrganisationDashboardAnalytics(
            currentOrganisationAccount?.organisationId as string
          )
        );
        if (res?.payload?.status === 200) {
          setIsLoading(false);
        }
      }
    };
    onLoad();
  }, []);

  return (
    <OrganisationLayout>
      {isLoading ? (
        <Spinner spinnerText={""} styles={""} />
      ) : (
        <>
          <div className="hidden lg:w-[80%] bg-white fixed top-0 lg:flex justify-between items-center w-full py-6 px-4 lg:px-12 transition">
            <div className="">
              <h3 className="text-[#0C4654] lg:block lg:text-[20px] font-[500] text-md">
                {dashboardInfo?.name || "Healthtracka"}
              </h3>
              <span className="text-[0.875rem]">
                Welcome 🤗, {currentOrganisationAccount?.firstName}
              </span>
            </div>

            <div className="">
              <div>
                <BaseButton
                  text="Order a Test"
                  variant="primary"
                  styles="!px-10 !text-[0.875rem] !font-[700]"
                  to={"/dashboard/customers?booking=true"}
                />{" "}
              </div>
            </div>
          </div>

          <div className="px-3 lg:px-12 pb-6 mt-32">
            <CardLists data={dashboardInfo} />
            <div className="bg-[#F2F6FA] mt-10 rounded-[1rem]">
              {dashboardInfo?.orders && dashboardInfo?.orders?.length > 0 ? (
                <>
                  {!show && (
                    <div className="py-4 mx-auto w-full px-6">
                      <p className="mb-6 font-[700] text-[0.875rem] text-[#0C4654]">
                        Recent Customers' Orders
                      </p>

                      {dashboardInfo?.orders
                        .slice(0, 5)
                        .map((order: Order) => (
                          <OrganisationOrderItem
                            key={order?.uniqueId}
                            order={order}
                          />
                        ))}

                      <div
                        onClick={() => navigate("/dashboard/orders")}
                        className="flex justify-end items-center cursor-pointer text-[#3A966C] hover:text-[#0C4654]"
                      >
                        <p className="font-[700] text-[1rem]  mx-2">
                          View all orders
                        </p>
                        <BsArrowRight />
                      </div>
                    </div>
                  )}

                  {show && (
                    <OrganisationDashboardResult
                      order={order}
                      handleShowModal={handleShowModal}
                    />
                  )}
                </>
              ) : (
                <>
                  <EmptyResult />
                </>
              )}
            </div>
          </div>
        </>
      )}
    </OrganisationLayout>
  );
};

export default OrganisationDashboard;

// export default WithOrganisationAuth(OrganisationDashboard);
